import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/apiClient";
import ProductCard from "@/components/ProductCard";
import { useLang } from "@/contexts/LanguageContext";

export default function WishlistPage() {
  const { user, loading } = useAuth();
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (user) api.get("/wishlist").then((r) => setItems(r.data)).catch(() => {});
  }, [user]);

  if (loading) return <div className="py-24 text-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12" data-testid="wishlist-page">
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">{t.product.wishlist}</h1>
      {items.length === 0 ? (
        <div className="border border-dashed border-neutral-300 p-16 text-center text-neutral-500">No items in wishlist yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
